module.exports = __webpack_public_path__ + "static/wallet@2x-0cc5aa9118fb0cfd0ba332b8559fd0af.png";